import type { AssayPanel, PanelAssayRef } from '@mariana/labos-client';

export function withConstantValue<Ref extends PanelAssayRef>(panel: AssayPanel<Ref>, name: string, value: number): AssayPanel<Ref> {
  const constant = panel.constants?.[name];
  if (!constant) throw new Error(`panel has no constant "${name}"`);
  return { ...panel, constants: { ...panel.constants, [name]: { ...constant, value } } };
}

export function parseConstantInput(text: string): number | null {
  if (!text.trim()) return null;
  const value = Number(text.trim());
  return Number.isFinite(value) ? value : null;
}
